import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { Router,ActivatedRoute } from '@angular/router';
import { FormGroup} from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner"; 

@Component({
  selector: 'app-add-product-subscriptions',
  templateUrl: './add-product-subscriptions.component.html',
  styleUrls: ['./add-product-subscriptions.component.css']
})
export class AddProductSubscriptionsComponent implements OnInit {

  constructor(public userService : UserService , private route: ActivatedRoute, public router:Router , private SpinnerService: NgxSpinnerService) {
    localStorage.setItem('selected_product', this.route.snapshot.params['id']);
    //console.log('page loaded');
  }
  productPackage = [];
  product_id : number;
  paymentType: string = 'M';
  paymentTypeName : string = '';
  licenseCount = [];
  licenseCountSelected = [];
  form : FormGroup;
  productImage:string='';
  freeTrial = false;
  freeTrialDays = '';
  product_image_url = this.userService.product_image_url;
  ngOnInit(): void {
    this.SpinnerService.show(); 
    let list = [];
    for (var i = 1; i <= 10; i++) {
      list.push(i);
    }
    this.licenseCount = list;
    this.product_id = this.route.snapshot.params['id'];
    this.paymentType = localStorage.getItem('package_type') != null ? localStorage.getItem('package_type') : 'M';
    this.userService.getProductPackage(this.product_id).subscribe((data: any) => {
      if (data.status == 1) {
        let i = 0;
        let array = [];
        var license_count_arr = localStorage.getItem('license_count_arr') != null ? JSON.parse(localStorage.getItem('license_count_arr')): {};
        this.productImage = data.productPackage[0].icon;
        data.productPackage.forEach(function (value) {
          
          const selected_license = license_count_arr !== undefined && license_count_arr[value.id] !== undefined && license_count_arr[value.id] != null ? license_count_arr[value.id] : '1';
          value.description_points = JSON.parse(value.description_points);
          value.selected_license = selected_license;
          array[i] = value;
          i++;
        });
        this.productPackage = array;
        this.paymentTypeName = this.paymentType == 'M' ? 'Month' : 'Year';
        this.SpinnerService.hide(); 
      }
      
    });

    this.form = new FormGroup({
      //licence_count: new FormControl(''),
    });
    const user_id = localStorage.getItem('nu_c_user_id');
    this.userService.checkFreeTrial(user_id).subscribe((data: any) => {
      //console.log(data);
      if (data.status == 1) {
        this.freeTrial = true;
        this.freeTrialDays = data.days;
      }
    });
  }

   
  paymentTypeChange(event){
    const target = event.checked;
    if(target){
      this.paymentType = 'M';
    }
    else{
      this.paymentType = 'Y';
    }
    localStorage.setItem('package_type', this.paymentType);
  }

  get f(){
    return this.form.controls;
  }
  
  submit(event){
    this.SpinnerService.show(); 
    const target = event.target;
    const package_id = target.querySelector(".package_id").value;
    const license_count = target.querySelector(".licence_count").value;
    let license_count_arr= {
    };
    license_count_arr[package_id] = license_count;
    this.licenseCountSelected = license_count;
    localStorage.setItem('license_count', license_count);
   // localStorage.setItem('license_count_arr', JSON.stringify(license_count_arr));
    this.router.navigate(['/checkout/'+package_id]);
  }

  /* getselectedLicense(id){
    var license_count_arr = JSON.parse(localStorage.getItem('license_count_arr'));
    return license_count_arr[id];
  } */
}
